export const PERSON_TYPES = {
  INDIVIDUAL: 'pessoa-fisica',
  COMPANY: 'pessoa-juridica',
};
